import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TypeCustomer, TypeCustomerForm, TypeTiers } from '../models';

@Injectable()
export class TypeCustomerService {

    typeCustomersUrl = environment.dns + 'api/type/customers/';

    constructor(private http: HttpClient) { }

    getList(): Observable<TypeTiers[]> {
        return this.http.get<TypeTiers[]>(this.typeCustomersUrl + 'list');
    }

    getOne(id: number): Observable<TypeTiers> {
        return this.http.get<TypeTiers>(this.typeCustomersUrl + id);
    }

    add(typeCustomerForm: TypeCustomerForm): Observable<TypeCustomer> {
        return this.http.post<TypeCustomer>(this.typeCustomersUrl, typeCustomerForm);
    }

    update(typeCustomerForm: TypeCustomerForm): Observable<TypeTiers> {
        return this.http.put<TypeTiers>(this.typeCustomersUrl, typeCustomerForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.typeCustomersUrl + id);
    }
}